import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Login.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
    if (error) setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Email is required');
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Email is invalid');
      return;
    }
    // Handle forgot password logic here
    console.log('Password reset requested for:', email);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-logo">
            <Link to="/" className="auth-logo-link">
              <span className="auth-logo-mana">Mana</span>
              <span className="auth-logo-wave">Wave</span>
            </Link>
          </div>
          <div className="auth-form-wrapper">
            <h2 className="auth-title">Check Your Email</h2>
            <p className="auth-subtitle">
              We've sent a password reset link to {email}
            </p>
            <div className="auth-alternate" style={{ marginTop: '2rem' }}>
              <Link to="/login" className="auth-button" style={{ textDecoration: 'none', display: 'block' }}>
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-logo">
          <Link to="/" className="auth-logo-link">
            <span className="auth-logo-mana">Mana</span>
            <span className="auth-logo-wave">Wave</span>
          </Link>
        </div>

        <div className="auth-form-wrapper">
          <h2 className="auth-title">Reset Password</h2>
          <p className="auth-subtitle">
            Enter your email address and we'll send you a link to reset your password
          </p>

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Email"
                value={email}
                onChange={handleChange}
                className={`form-input ${error ? 'error' : ''}`}
              />
              {error && <span className="error-message">{error}</span>}
            </div>

            <button type="submit" className="auth-button">
              Send Reset Link
            </button>
          </form>

          <div className="auth-alternate">
            <p>
              Remember your password?{' '}
              <Link to="/login" className="auth-link">Login</Link>
            </p>
          </div>
        </div>

        <div className="auth-footer">
          <p className="privacy-note">
            We respect your privacy. Your data is safe.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;



